import { staffApi } from '../api/modules/staff.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { getStaffUsers } from '../data/staff/staffStore';
import { mapPaginated, staffFromApi, staffToApi } from '../models';

export async function listStaff(params = {}) {
  if (!USE_API) {
    let items = [...getStaffUsers()];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (s) =>
          s.fullName?.toLowerCase().includes(q) ||
          s.email?.toLowerCase().includes(q) ||
          s.staffId?.toLowerCase().includes(q),
      );
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 10;
    const start = (page - 1) * pageSize;
    return {
      items: items.slice(start, start + pageSize),
      total: items.length,
      page,
      pageSize,
    };
  }
  try {
    const result = await staffApi.list(params);
    return mapPaginated(result, staffFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load staff'));
  }
}

export async function getStaff(id) {
  if (!USE_API) {
    return (
      getStaffUsers().find(
        (s) => s.staffId === id || String(s.id) === String(id),
      ) || null
    );
  }
  try {
    return staffFromApi(await staffApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load staff user'));
  }
}

export async function createStaff(ui) {
  if (!USE_API) throw new Error('Create staff requires API mode');
  try {
    return staffFromApi(await staffApi.create(staffToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create staff'));
  }
}

export async function updateStaff(id, ui) {
  if (!USE_API) throw new Error('Update staff requires API mode');
  try {
    return staffFromApi(await staffApi.update(id, staffToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update staff'));
  }
}

export async function assignStaffRoles(id, roleIds) {
  if (!USE_API) throw new Error('Assign roles requires API mode');
  try {
    return staffFromApi(await staffApi.assignRoles(id, roleIds));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to assign roles'));
  }
}

export async function changeStaffPassword(id, body) {
  if (!USE_API) throw new Error('Change password requires API mode');
  try {
    const payload = {
      newPassword: body.newPassword || body.password,
      ...(body.currentPassword != null && body.currentPassword !== ''
        ? { currentPassword: body.currentPassword }
        : {}),
    };
    await staffApi.changePassword(id, payload);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to change password'));
  }
}

export async function deleteStaff(id) {
  if (!USE_API) throw new Error('Delete staff requires API mode');
  try {
    await staffApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete staff'));
  }
}
